// extracted by css-extract-rspack-plugin
export default {"cls1":"PremiumLock-cls1_sn_","cls2":"PremiumLock-cls2_r-y PremiumLock-cls1_sn_"};